import { InputField } from './InputField'

export default InputField;